import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.4_@babel+core@7.27.7_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.4_@babel+core@7.27.7_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/become-security-compliant/admins.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/become-security-compliant/founders.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/become-security-compliant/human.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/blue-tick-circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/campass-border.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/clock.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/cloud-border.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/graph.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/laptop.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/setting-play.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/settings.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/shield-border.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/user-laptop.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/common/white-shield.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/admins1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/cto1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/efficiency.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/founder1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/hero1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/hr1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/mobile-hero-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/security.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/for-founders-hr-it-and-admins/transparency.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/loader/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/two-parts-info-boxes-section/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/button/button.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/gradient-text/styles.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/section-wrapper/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/for-founders-it-hr-and-admins/hero/Hero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/page-components/for-founders-it-hr-and-admins/zenadmin-benefits/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/page-layout/PageLayout.tsx");
